import React from 'react';
import { BaseIcon } from '../base/BaseIcon';
import { IconProps } from '../types';

export const DangerTriangleFilled = React.memo<IconProps>(
  ({
    className = '',
    size = 24,
    color = 'currentColor',
    onClick,
    strokeWidth,
  }) => (
    <BaseIcon
      className={className}
      size={size}
      color={color}
      onClick={onClick}
      viewBox="0 0 24 24"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9.70139 3.66655C10.7102 1.87303 13.2911 1.87303 14.2986 3.66655L21.6573 16.7487C22.6464 18.5079 21.3764 20.6786 19.36 20.6786H4.64129C2.62359 20.6786 1.35362 18.5079 2.34269 16.7487L9.70139 3.66655ZM13.3188 16.7236C13.3188 17.0734 13.1798 17.4088 12.9325 17.6561C12.6852 17.9034 12.3497 18.0424 12 18.0424C11.6502 18.0424 11.3148 17.9034 11.0675 17.6561C10.8202 17.4088 10.6812 17.0734 10.6812 16.7236C10.6812 16.3739 10.8202 16.0384 11.0675 15.7911C11.3148 15.5438 11.6502 15.4049 12 15.4049C12.3497 15.4049 12.6852 15.5438 12.9325 15.7911C13.1798 16.0384 13.3188 16.3739 13.3188 16.7236ZM12 6.17352C11.6502 6.17352 11.3148 6.31246 11.0675 6.55977C10.8202 6.80709 10.6812 7.14252 10.6812 7.49228V11.4486C10.6812 11.7983 10.8202 12.1338 11.0675 12.3811C11.3148 12.6284 11.6502 12.7673 12 12.7673C12.3497 12.7673 12.6852 12.6284 12.9325 12.3811C13.1798 12.1338 13.3188 11.7983 13.3188 11.4486V7.49228C13.3188 7.14252 13.1798 6.80709 12.9325 6.55977C12.6852 6.31246 12.3497 6.17352 12 6.17352Z"
        fill={color}
      />
    </BaseIcon>
  ),
);

DangerTriangleFilled.displayName = 'DangerTriangleFilled';
